module.exports = __webpack_public_path__ + "img/banner-27.7076d3dd.jpg";